import { r as redirect } from "../../../../../chunks/index2.js";
const GET = () => {
  throw redirect(302, "/releases/latest/glimmr-setup.exe");
};
export {
  GET
};
